import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CriminalRecord, AliasName, ApplicantTaxLien, EvictionRecord, PreviousAddress, SSNTrace, EmploymentVerification, ReferenceVerification, VerificationCall, EmployerVerificationData, ReferenceVerificationData } from '../models/ApplicantDataResponses/ApplicantDataResponses';
import { ScreeningInvite, Screening, ScreeningLight, ObjectUpdatePayload, TriggerRecordTogglePayload } from '../models/screeningInvite';
import { SearchPackage, SearchRecord, VendorResponseTypes, CustomResponseData } from '../packages-module/models/searchPackage';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CustomAlias } from '../models/ApplicantDataModels/CustomAlias';
import { CustomAddress } from '../models/ApplicantDataModels/CustomAddress';
import { ASENote } from '../models/ASENote';
import { HardDeclineReason } from '../models/hardDeclineReason';
import {delay, finalize, tap} from 'rxjs/operators';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { PrintQueueRequest } from '../models/printQueueRequest';
import { IncomeVerification } from '../models/ApplicantDataModels/Income_Verification';
import { GroupedApplicantData, GroupIncomeStats } from '../models/ApplicantDataModels/GroupedApplicantData';
import { ArgyleViewBag, ArgyleViewBagResponse, AdditionalIncomeSource, InviteCreateRequest, ArgyleInviteSent, IncomeStreamType, ArgyleIncomeStream, IncomeStreamExclusionReason } from '../models/Argyle';
import {
  DraftIncomeSource,
  ReadinessResponse,
  SaveDraftIncomeSourceRequest,
  WizardStartRequest,
  WizardWorkflowState,
} from '../models/income-wizard-workflow';

@Injectable({
  providedIn: 'root'
})
export class ApplicantDataService {
  public get criminalRecords(): Array<CriminalRecord> {
    if (!this._criminalRecords) { return []; }
    return this._criminalRecords.filter(er => er.searchType == 'multistate');
  }
  public get countyCriminalRecords(): Array<CriminalRecord> {
    if (!this._criminalRecords) { return []; }
    return this._criminalRecords.filter(er => er.searchType != 'multistate');
  }
  public incomeSourceTypes : any[]= [
    {id : 0, name : 'Tax Documents'},
    {id : 1, name : 'VA/TANF/SSI'},
    {id : 2, name : 'Bank Statements'},
    {id : 3, name : 'Employment Offer'},
    {id : 4, name : 'Current Employment'},
    {id : 5, name : 'Other Income'},
    {id : 6, name : 'Pay Stubs'},
    {id : 7, name : 'W2'}
  ];

  public get stateCriminalDatabaseRecords(): Array<CriminalRecord> {
    if (this._criminalRecords) { return this._criminalRecords.filter(er => er.searchType == 'singlestate'); } else { return []; }
  }

  public get stateCriminalCourtRecords(): Array<CriminalRecord> {
    if (this._criminalRecords) { return this._criminalRecords.filter(er => er.searchType == 'statewide'); } else { return []; }
  }

  public get utahJusticeCourtRecords(): Array<CriminalRecord> {
    if (this._criminalRecords) { return this._criminalRecords.filter(er => er.searchType == 'UtahJusticeCourtScrape'); } else { return []; }
  }

  public get utahDistrictCourtRecords(): Array<CriminalRecord> {
    if (this._criminalRecords) { return this._criminalRecords.filter(er => er.searchType == 'UtahDistrictCourtScrape'); } else { return []; }
  }

  public get ofacRecords() : Array<CriminalRecord> {
    if (this._criminalRecords) { return this._criminalRecords.filter(er => er.searchType == 'ofac'); } else return [];
  }
  public get evictionRecords(): Array<EvictionRecord> {
    if (!this._evictionRecords) { return []; }
    return this._evictionRecords;
  }
  public get addressRecords(): Array<PreviousAddress> {
    if (!this._addressRecords) { return []; }
    return this._addressRecords;
  }
  public get taxLienRecords(): Array<ApplicantTaxLien> {
    if (!this._taxLienRecords) { return []; }
    return this._taxLienRecords;
  }
  public get judgmentRecords(): Array<ApplicantTaxLien> {
    if (!this._judgmentRecords) { return []; }
    return this._judgmentRecords;
  }
  public get bankruptcyRecords(): Array<ApplicantTaxLien> {
    if (!this._bankruptcyRecords) { return []; }
    return this._bankruptcyRecords;
  }
  public get aliasRecords(): Array<AliasName> {
    if (!this._aliasRecords) { return []; }
    return  this._aliasRecords;
  }
  public get verifyEmploy(): EmploymentVerification {
    if (this._verifyEmploy) { return this._verifyEmploy; } else { return null; }
  }
  public get verifyReference(): ReferenceVerification {
    if (this._verifyReference) { return this._verifyReference; } else { return null; }
  }
  public get verifyIncome(): IncomeVerification {
    if(this._verifyIncome) { return this._verifyIncome } else { return null; } 
  }
  constructor(
    private http: HttpClient,
    private toast: ToastrService) { }
  applicantId: number;
  reportViewMode: boolean;
  printReport : PrintQueueRequest;
  _criminalRecords: Array<CriminalRecord>;

  _countyCriminalRecords: Array<CriminalRecord>;

  _evictionRecords: Array<EvictionRecord>;

  _addressRecords: Array<PreviousAddress>;
  _statesAndCounties: Array<PreviousAddress>;

  _taxLienRecords: Array<ApplicantTaxLien>;

  _judgmentRecords: Array<ApplicantTaxLien>;

  _bankruptcyRecords: Array<ApplicantTaxLien>;

  _aliasRecords: Array<AliasName>;

  _verifyEmploy: EmploymentVerification;

  _verifyReference: ReferenceVerification;

  _verifyIncome: IncomeVerification;

  customSearchRecords: Array<CustomResponseData> = [];
  ssnRecords: SSNTrace;
  token: string;
  password: string;
  screeningInvite: ScreeningInvite;
  screening: Screening;
  // screeningLight: ScreeningLight;
  packages: Array<SearchPackage>;
  ssnYears: Array<string>;
  loadComplete = false;
  criminalSearchDepth = '';

  public addressRecordsLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public aliasRecordsLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public ssnTraceRecordsLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public criminalRecordsLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public judgmentRecordsLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public taxLienRecordsLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public bankruptcyRecordsLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public evictionRecordsLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public customSearchRecordsLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public incomeVerificationLoadingSubject$ = new BehaviorSubject<boolean>(false);

  public $crimRecordsLoaded : EventEmitter<boolean> = new EventEmitter();
  public $evicRecordsLoaded : EventEmitter<boolean> = new EventEmitter();
  public verificationResultResponses: string[] = ['Yes', 'No', 'Pending', 'Not Performed'];

  public FetchApplicantData(): void {

    // TODO : pull the package and searches in it. then filter based on that.
    this.http.get<Array<SearchPackage>>(environment.baseURl + `/api/search/package/` + this.screeningInvite.searchPackageId).subscribe(
      (scs: Array<SearchPackage>) => {
        this.packages = scs;
      },
      (err: any) => {
        this.toast.error('There was an error looking up your search package.', 'Search Package');
      },
    );
  }

  public GetAddressRecordsForApplicant(screeningId : number): void {

    this.addressRecordsLoadingSubject$.next(true);

    this.http.get<Array<PreviousAddress>>(environment.baseURl + `/api/applicantdata/address/` + screeningId)
      .pipe(finalize(() => this.addressRecordsLoadingSubject$.next(false))).subscribe(
      (scs: any) => {
        this._addressRecords = scs.map(e => Object.assign(new PreviousAddress, e));
      },
      (err: any) => {
        this.toast.error('ADDRESS RECORD LOAD ERROR')
      },
    );
  }

  public GetAddressStatesAndCounties(screeningId : number): void {

    this.addressRecordsLoadingSubject$.next(true);

    this.http.get<Array<PreviousAddress>>(environment.baseURl + `/api/applicantdata/crimStates/` + screeningId)
      .pipe(finalize(() => this.addressRecordsLoadingSubject$.next(false))).subscribe(
      (scs: any) => {
        this._statesAndCounties = scs.map(e => Object.assign(new PreviousAddress, e));
      },
      (err: any) => {
        this.toast.error('ADDRESS RECORD LOAD ERROR')
      },
    );
  }


  public GetAliasNameRecordsForApplicant(screeningId : number): void {

    this.aliasRecordsLoadingSubject$.next(true);

    this.http.get<Array<AliasName>>(environment.baseURl + `/api/applicantdata/alias/` + screeningId)
      .pipe(finalize(() => {this.aliasRecordsLoadingSubject$.next(false);})).subscribe(
      (scs: any) => {
        
        this._aliasRecords = scs.map(e=>Object.assign(new AliasName, e));
      },
      (err: any) => {
      },
    );
  }

  public GetSSNTraceForApplicant(aseId : number): void {

    this.ssnTraceRecordsLoadingSubject$.next(true);

    this.http.get<Array<SSNTrace>>(environment.baseURl + `/api/applicantdata/ssn/` + aseId)
      .pipe(finalize(() => this.ssnTraceRecordsLoadingSubject$.next(false))).subscribe(
      (scs: any) => {
        this.ssnRecords = scs;
        if (this.ssnRecords) {
          if (this.ssnRecords.ssnYear !== undefined && this.ssnRecords.ssnYear.indexOf('-') > 0) {
            this.ssnYears = this.ssnRecords.ssnYear.split('-');
          } else {
            this.ssnYears = new Array<string>();
            this.ssnYears.push(this.ssnRecords.ssnYear);
          }
        }

      },
      (err: any) => {
      },
    );
  }

  public GetCriminalRecordsForApplicant(aseId: number): void {

    this.criminalRecordsLoadingSubject$.next(true);

    this.http.get<Array<CriminalRecord>>(environment.baseURl + `/api/applicantdata/criminal/` + aseId)
      .pipe(finalize(() => this.criminalRecordsLoadingSubject$.next(false))).subscribe(
      (scs: any) => {
        scs.forEach(element => {
          element.selected = true;
        });
        this._criminalRecords = scs.map(r => Object.assign(new CriminalRecord, r));
        if (this._criminalRecords.length > 0) {
          this.criminalSearchDepth = this._criminalRecords[0].searchType == 'multistate' ? 'Nationwide' : this._criminalRecords[0].searchType;
        }
      },
      (err: any) => {
      },()=>{ this.$crimRecordsLoaded.emit(true);}
    );
  }

  public HasUnfilteredCriminalRecords(screeningId: number): Observable<boolean> {
    return this.http.get<boolean>(environment.baseURl + `/api/applicantData/criminal/existing/` + screeningId);
  }

  public GetJudgmentRecordsForApplicant(): void {

    this.judgmentRecordsLoadingSubject$.next(true);

    this.http.get<Array<ApplicantTaxLien>>(environment.baseURl + `/api/applicantdata/judgment/` + this.token)
      .pipe(finalize(() => this.judgmentRecordsLoadingSubject$.next(false))).subscribe(
      (scs: any) => {
        this._judgmentRecords = scs.map(c => Object.assign(new ApplicantTaxLien, c));
      },
      (err: any) => {
      },
    );
  }

  public GetTaxLienRecordsForApplicant(): void {

    this.taxLienRecordsLoadingSubject$.next(true);

    this.http.get<Array<ApplicantTaxLien>>(environment.baseURl + `/api/applicantdata/lien/` + this.token)
      .pipe(finalize(() => this.taxLienRecordsLoadingSubject$.next(false))).subscribe(
      (scs: any) => {
        this._taxLienRecords = scs.map(c => Object.assign(new ApplicantTaxLien, c));
      },
      (err: any) => {
      },
    );
  }

  public GetBankruptcyRecordsForApplicant(): void {

    this.bankruptcyRecordsLoadingSubject$.next(true);

    this.http.get<Array<ApplicantTaxLien>>(environment.baseURl + `/api/applicantdata/bankrupcty/` + this.token)
      .pipe(finalize(() => this.bankruptcyRecordsLoadingSubject$.next(false))).subscribe(
      (scs: any) => {
        this._bankruptcyRecords = scs.map(c => Object.assign(new ApplicantTaxLien, c));
      },
      (err: any) => {
        console.error('Error fetch Bankruptcy Records');
      },
    );
  }

  public GetEvictionRecordsForApplicant(id : number): void {

    this.evictionRecordsLoadingSubject$.next(true);

    console.log('LOADING EVICTION RECORDS');

    this.http.get<Array<EvictionRecord>>(environment.baseURl + `/api/applicantdata/eviction/` + id)
      .pipe(finalize(() => this.evictionRecordsLoadingSubject$.next(false)))
      .subscribe(
        (scs: any) => {
          scs.forEach(element => {
            element.selected = true;
          });
          this._evictionRecords = scs.map(c=> Object.assign(new EvictionRecord,c));
        },
        (err: any) => {
        },()=>{
          this.$evicRecordsLoaded.next(true);
        }
      );
  }


  public FireOffConsumerDisclosureEmail(id : number) {
    return this.http.get<Array<EvictionRecord>>(environment.baseURl + `/api/values/disclose/` + id);
  }
  public FireOffConsumerDisclosureEmail2(dta : any) {
    return this.http.post(environment.baseURl + `/api/values/disclose/override`, dta);
  }
  public SendIDVerNoPhoneEmail(screeningId: number) {
    return this.http.get(environment.baseURl + `/api/messaging/send/idvernophone/` + screeningId);
  }

  public SendIDVerMissingInfoEmail(screeningId: number) {
    return this.http.get(environment.baseURl + `/api/messaging/send/idvermissinginfo/` + screeningId);
  }

  GetIncomeVerificationData(aseId: number) {
    this.incomeVerificationLoadingSubject$.next(true);

    this.http.get<IncomeVerification>(environment.baseURl + `/api/applicantdata/income-ver/` + aseId)
      .pipe(finalize(() => this.incomeVerificationLoadingSubject$.next(false)), tap(_ => this._verifyIncome = _)).subscribe();
  }

  sortByKey(collection : any, key : string, asc : boolean) : any[] {
    return collection.sort((a, b) => {
      if(asc) {
        if(a[key] == b[key]) return 0;
        if(a[key] == null || a[key] == '') return 1;
        if(b[key] == null || b[key] == '') return -1;
        if(a[key] < b[key]) return -1;
        if(a[key] > b[key]) return 1;
      } else {
        if(a[key] == b[key]) return 0;
        if(a[key] == null || a[key] == '') return -1;
        if(b[key] == null || b[key] == '') return 1;
        if(a[key] > b[key]) return -1;
        if(a[key] < b[key]) return 1;
      }
    });
  }

  GetEmploymentVerifications(aseId: number) {
    return this.http.get<EmploymentVerification>(`${environment.baseURl}/api/applicantdata/verification/employment/${aseId}`);
  }

  GetASENotes(aseId: number) {
    return this.http.get<ASENote[]>(`${environment.baseURl}/api/search/notes/fetch/${aseId}`);
  }

  GetReferenceVerifications(aseId: number) {
    return this.http.get<ReferenceVerification>(`${environment.baseURl}/api/applicantdata/verification/reference/${aseId}`);
  }

  GetApplicantEmploymentData(token: number) {
    return this.http.get<EmployerVerificationData>(`${environment.baseURl}/api/applicantdata/verdata/employment/${token}`);
  }

  GetApplicantReferenceData(token: number) {
    return this.http.get<ReferenceVerificationData>(`${environment.baseURl}/api/applicantdata/verdata/reference/${token}`);
  }

  GetCustomSearchResponseRecords(aseId: number) {
    return this.http.get<CustomResponseData[]>(environment.baseURl + `/api/applicantdata/custom-search/${aseId}`);
  }

  GetCustomSearchRecordStubs(screeningId: number) {
    return this.http.get<SearchRecord[]>(environment.baseURl + `/api/applicantdata/custom-search/stubs/${screeningId}`);
  }

  SaveCustomSearchData(d: CustomResponseData) {
    return this.http.post(environment.baseURl + '/api/search/custom-search', d);
  }


  FetchPreviousAliasesForScreening(token: string) {
    return this.http.get<CustomAlias[]>(environment.baseURl + `/api/applicantdata/previous-alias/${token}`);
  }

  FetchPreviousAddressesForScreening(token: string) {
    return this.http.get<CustomAddress[]>(environment.baseURl + `/api/applicantdata/previous-address/${token}`);
  }

  AddAliasForScreening(alias: CustomAlias) {
    // should return a bool if create was successful
    return this.http.post(environment.baseURl + `/api/applicantdata/previous-alias`, alias);
  }

  AddPreviousAddressForScreening(address: CustomAddress) {
    // should return a bool if create succeeds
    return this.http.post(environment.baseURl + `/api/applicantdata/previous-address`, address);
  }

  ToggleReportItemVisibility(payload: Array<ObjectUpdatePayload>) {
    return this.http.post(environment.baseURl + `/api/applicantdata/exclude/record`, payload);
  }

  ToggleRecord2(pld : TriggerRecordTogglePayload[]) {
    return this.http.post(environment.baseURl + `/api/applicantdata/toggle-record`, pld);
  }

  RemoveAliasForScreening(alias: CustomAlias) {
    return this.http.post(environment.baseURl + `/api/applicantdata/previous-alias/delete`, alias);
  }

  RemoveAddressForScreening(address: CustomAddress) {
    return this.http.post(environment.baseURl + '/api/applicantdata/previous-address', address);
  }

  RemoveHardDeclineReasonForScreening(reason: HardDeclineReason) {
    return this.http.post(environment.baseURl + '/api/applicantdata/decline/reason/disassociate', reason);
  }

  AddHardDeclineReasonToScreening(reason: HardDeclineReason) {
    return this.http.post(environment.baseURl + '/api/applicantdata/decline/reason/associate', reason);
  }

  SaveVerificationCallAttempt(call: VerificationCall, isResVer: boolean) {
    return this.http.post(environment.baseURl + `/api/sjv/callAttempt`, {call, type : isResVer ? 2 : 3});
  }

  GetReportPDF(reportNumber : number){
    return this.http.get(environment.baseURl + `/api/values/pdf/${reportNumber}`);
  }

  GetGroupIncome(reportNumber : number) {
    return this.http.get<GroupIncomeStats>(environment.baseURl + `/api/GroupApplicant/income/${reportNumber}`); 
  }

  GetArgyleDataForReport(scrn : number){
    return this.http.get<ArgyleViewBagResponse>(environment.baseURl + `/api/incomever/fetch/${scrn}`); 
  }

  GetInviteFailure(screeningId: number) {
    return this.http.get<any>(environment.baseURl + `/api/incomever/invite-failure/${screeningId}`);
  }

  ResolveInviteFailure(screeningId: number) {
    return this.http.post<any>(environment.baseURl + `/api/incomever/invite-failure/resolve`, { screeningId });
  }

  GetIncomeStreamExclusionReasons() {
    return this.http.get<IncomeStreamExclusionReason[]>(
      environment.baseURl + '/api/incomever/exclusion-reasons'
    );
  }

  RefreshIncomeStream(scrn: number, tp : IncomeStreamType)
  {
    return this.http.get(environment.baseURl+`/api/incomever/refresh/${scrn}/${tp}`);
  }

  GetAdditionalIncomeSources(scrn : number){
    return this.http.get<AdditionalIncomeSource[]>(environment.baseURl + `/api/incomever/incomesource/fetch/${scrn}`); 
  }

  SaveAdditionalIncomeSource(src : AdditionalIncomeSource){
    return this.http.post(environment.baseURl + `/api/incomever/source/save`,src);
  }

  RemoveIncomeSource(src : AdditionalIncomeSource){
      return this.http.post<boolean>(environment.baseURl + `/api/incomever/incomesource/remove`,src); 
  }

  FireArgyleInviteInternal(rqst : InviteCreateRequest){
    return this.http.post(environment.baseURl + `/api/incomever/init/internal`, rqst);
  }

  ResendArgyleInvite(rqst : ArgyleInviteSent){
    return this.http.post(environment.baseURl + `/api/incomever/invite/resend`, rqst);
  }

  ReprocessArgyleInvite(rqst : Screening, reportNumber: number, skipTWN: boolean = false){
    return this.http.post(environment.baseURl + `/api/incomever/invite/reprocess/${skipTWN}/${reportNumber}`, rqst);
  }

  CompleteStrandedIncomeVer(screeningId: number, inviteId: number) {
    return this.http.post<{ success: boolean }>(environment.baseURl + `/api/incomever/complete-stranded`, { screeningId, inviteId });
  }

  DownloadArgyleDoc(id : string, name: string, inviteId : number , type : number){
    return this.http.post(environment.baseURl + `/api/incomever/download/intr`, { id,name, inviteId, type }, { responseType: 'blob' });
  }

  /** Proxy-download an Argyle authenticity overlay image by its full URL. */
  downloadOverlayProxy(url: string) {
    return this.http.post(
      environment.baseURl + `/api/incomever/download/overlay-proxy`,
      { url },
      { responseType: 'blob' }
    );
  }

  getWizardState(screeningId: number) {
    return this.http.get<WizardWorkflowState>(
      environment.baseURl + `/api/incomever/wizard-state/${screeningId}`
    );
  }

  isWizardEnabledForProperty(locationId: number) {
    return this.http.get<{ enabled: boolean, enabledDate: string | null }>(
      environment.baseURl + `/api/incomever/wizard-enabled/${locationId}`
    );
  }

  startOrResumeWizard(screeningId: number, body: WizardStartRequest = { overrodeReadiness: false }) {
    return this.http.post<WizardWorkflowState>(
      environment.baseURl + `/api/incomever/wizard-state/start/${screeningId}`,
      body
    );
  }

  advanceWizardPhase(screeningId: number) {
    return this.http.post<WizardWorkflowState>(
      environment.baseURl + `/api/incomever/wizard-state/advance/${screeningId}`,
      {}
    );
  }

  finalizeIncomeWizard(screeningId: number) {
    return this.http.post<{ success: boolean; monthlyIncomeUpdated?: boolean }>(
      environment.baseURl + `/api/incomever/wizard/finalize/${screeningId}`,
      {}
    );
  }

  // Loads readiness gates from sp_IncomeWizard_CheckReadiness.
  checkReadiness(screeningId: number): Observable<ReadinessResponse> {
    return this.http.get<ReadinessResponse>(
      environment.baseURl + `/api/incomever/wizard/readiness/${screeningId}`
    );
  }

  saveWizardDraftSource(draft: SaveDraftIncomeSourceRequest) {
    return this.http.post<DraftIncomeSource>(
      environment.baseURl + '/api/incomever/wizard/draft-source',
      draft
    );
  }

  getWizardDraftSources(screeningId: number) {
    return this.http.get<DraftIncomeSource[]>(
      environment.baseURl + `/api/incomever/wizard/draft-sources/${screeningId}`
    );
  }

  updateWizardStreamIndex(screeningId: number, streamIndex: number) {
    return this.http.patch<WizardWorkflowState>(
      environment.baseURl + `/api/incomever/wizard-state/stream-index/${screeningId}`,
      { streamIndex }
    );
  }

  /** Remove a wizard draft income source row (overview corrections). */
  // deleteWizardDraftSource(id: number) {
  //   return this.http.delete<{ success: boolean }>(
  //     environment.baseURl + `/api/incomever/wizard/draft-source/${id}`
  //   );
  // }
}

